export default __webpack_public_path__ + "static/media/aman.38cda6ce.jpg";